import projectListTemplateService from '../services/templates/project_list_template_service';
import CreateFileTemplatePage from './CreateFileTemplatePage';
const ProjectListTemplatePage = CreateFileTemplatePage({
  service: projectListTemplateService,
  templateType: 'project_list_template',
  fileType: 'xlsx'
});
export default ProjectListTemplatePage;